import "@elaso/ui/styles";

import { createRouter } from "@elaso/ui/router";
import { initSentry, sentryCreateRootOptions } from "@elaso/ui/sentry";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const router = createRouter();

initSentry(router, {
	dsn: "https://56900316941d5f09404b7c7db8139075@o4510698725834752.ingest.de.sentry.io/4510800250470480",
	tunnel: `${import.meta.env.VITE_SERVER_URL}/tunnel`,
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement, sentryCreateRootOptions).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>
);
